<script setup lang="ts">
import type { Product } from "mws-ts-v2-sdk";

type Props = {
  products?: Product[];
  gridAmount: 4 | 2;
  isMobile?: boolean;
};

defineProps<Props>();

type Emits = {
  (e: "product-clicked", product: Product): void;
};

defineEmits<Emits>();
</script>

<template>
  <ProductSectionProductsGrid
    :data-cy="`${isMobile ? 'mobile' : 'desktop'}-quick-search-products-grid`"
    :products="products ?? []"
    tracking-source="quickSearch"
    :grid-amount="gridAmount"
    @product-clicked="(product) => $emit('product-clicked', product)"
  />
</template>
